import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';

interface Props {
  feriado?: FormFeriado;
  onSubmit: (feriado: FormFeriado) => void;
  onCancel?: () => void;
}

interface FormFeriado {
  id_feriado?: number;
  dsc_feriado: string;
  dat_feriado: string;
}

const FormularioFeriado: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_feriado',
      label: 'Id do feriado',
      type: 'number',
      defaultValue: props.feriado?.id_feriado,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'dsc_feriado',
      label: 'Nome do feriado',
      type: 'text',
      defaultValue: props.feriado?.dsc_feriado,
      required: true,
      component: InputForm,
    },
    {
      name: 'dat_feriado',
      label: 'Data do feriado',
      type: 'date',
      defaultValue: props.feriado?.dat_feriado,
      required: true,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='feriado'
      is_edit={Boolean(props.feriado)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioFeriado };
export type { FormFeriado };
